// extracted by mini-css-extract-plugin
export default {"body":"LayoutAuth_body__-hFDB","wrapper":"LayoutAuth_wrapper__96JUc"};